import $ from "cash-dom";

class MobileMenu {
	constructor() {
		const _ = this;
		_.open = false;
		_.mobileMenuButton = $("#mobile-menu-button");
		_.mobileMenu = $("#mobile-menu");
		_.bindUI();
	}

	bindUI() {
		const _ = this;

		$('[data-action="toggle-mobile-menu"]').on("click", (e) => {
			e.preventDefault();
			if (_.open) {
				_.hide();
				return;
			}
			_.show();
		});

		$('[data-action="show-mobile-menu"]').on("click", (e) => {
			e.preventDefault();
			_.show();
		});

		$('[data-action="hide-mobile-menu"]').on("click", (e) => {
			e.preventDefault();
			_.hide();
		});

		let mobileMenuStack = ["root"];

		// Segue forward to selected menu panel
		$('[data-action="segue-to-mobile-nav"]').on("click", function (e) {
			let childHandle = this.getAttribute("data-nav-child");
			let thisMenu = $(this).closest(".mobile-nav-list");
			let nextMenu = $('[data-nav-handle="' + childHandle + '"]');

			thisMenu.addClass("position-left");
			nextMenu.removeClass("position-right");

			// transfer focus
			nextMenu.find('[data-focus="start"]')[0].focus();

			// push to stack
			mobileMenuStack.push(childHandle);
		});

		// Segue backwards to previous menu panel
		$('[data-action="segue-back"]').on("click", function (e) {
			// pop from stack
			let currentMenu = mobileMenuStack.pop();

			$('[data-nav-handle="' + currentMenu + '"]').addClass("position-right");

			let previousMenuHandle = mobileMenuStack[mobileMenuStack.length - 1];
			let prevMenu = $('[data-nav-handle="' + previousMenuHandle + '"]');
			prevMenu.removeClass("position-left");
			// transfer focus
			prevMenu.find('[data-focus="start"]')[0].focus();
		});
	}

	show() {
		const _ = this;
		_.mobileMenuButton.attr("aria-expanded", "true");
		_.mobileMenu.attr("aria-hidden", "false");
		document.body.style.overflow = "hidden";
		_.open = true;
	}

	hide() {
		const _ = this;
		_.mobileMenuButton.attr("aria-expanded", "false");
		_.mobileMenu.attr("aria-hidden", "true");
		document.body.style.overflow = "";
		_.open = false;
	}
}

const mobileMenu = new MobileMenu();

let Luna = window.Luna || {};
Luna.mobileMenu = mobileMenu;

export { mobileMenu };
